import Swiper from "swiper/bundle";
import "../../node_modules/swiper/swiper.scss";

document.addEventListener("DOMContentLoaded", () => {
  if (window.innerWidth <= 1199) {
    new Swiper(".swiper-container", {
      direction: "horizontal",
      loop: false,
      pagination: {
        el: ".swiper-pagination",
      },

      breakpoints: {
        300: {
          slidesPerView: 1,
          spaceBetween: 25,
          width: 320,
        },
        480: {
          slidesPerView: 1,
          spaceBetween: 30,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        968: {
          slidesPerView: 2,
          spaceBetween: 0,
        },
        1199: {
          slidesPerView: 3,
          spaceBetween: 0,
        },
      },
    });
  }
});
